export enum PaymentActivityType {
  Regular = "Regular",
  Free = "Free",
  Extended = "Extended"
}
